import { FaqProps } from "@ft/components/common/Faq";

const ToLowercaseFaqData: FaqProps[] = [
  {
    question: "What is this tool?",
    ans: "This is a free online tool that converts any text you enter into lowercase.",
  },
  {
    question: "Is it free to use?",
    ans: "Yes, the tool is completely free to use with no limitations.",
  },
  {
    question: "Does the tool preserve formatting?",
    ans: "No, the tool does not preserve formatting such as bold, italics, or underline.",
  },
  {
    question: "Can I copy and paste the converted text?",
    ans: "Yes, Converted text can be easily copied and pasted into any other application.",
  },
  {
    question: "Is there a limit on the amount of text I can convert?",
    ans: "No, there is no limit on the amount of text you can convert.",
  },
  {
    question: "What types of text can I convert?",
    ans: "You can convert any type of text, including sentences, paragraphs, articles, code, and more.",
  },
  {
    question: "What are the steps to use the tool?",
    ans: "To view the result in lowercase, simply paste your text into the input box.",
  },
];

export default ToLowercaseFaqData;
